const mutableRuntimeProperties = ['apiUrl', 'apiURL', 'apiURLSSL'];

module.exports = mutableRuntimeProperties;
